const TOPICS = [
  { id: 1, label: '热门电影', hot: '256万', icon: 'ri-fire-line' },
  { id: 2, label: '电视剧', hot: '198万', icon: 'ri-tv-line' },
  { id: 3, label: '综艺节目', hot: '167万', icon: 'ri-emotion-laugh-line' },
  { id: 4, label: '动漫', hot: '142万', icon: 'ri-ancient-gate-line' },
  { id: 5, label: '纪录片', hot: '89万', icon: 'ri-earth-line' },
  { id: 6, label: '动作片', hot: '213万', icon: 'ri-flashlight-line' },
  { id: 7, label: '喜剧', hot: '178万', icon: 'ri-emotion-happy-line' },
  { id: 8, label: '悬疑', hot: '156万', icon: 'ri-search-eye-line' },
  { id: 9, label: '科幻', hot: '134万', icon: 'ri-rocket-line' },
  { id: 10, label: '爱情', hot: '121万', icon: 'ri-heart-line' },
  { id: 11, label: '恐怖', hot: '98万', icon: 'ri-ghost-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">大家都在看的热门分类，快速找到你的喜好</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-2.5 bg-background-50 border border-background-200/60 rounded-full px-4 py-2.5 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center bg-background-100 rounded-full group-hover:bg-primary-100 transition-colors">
                <i className={`${topic.icon} text-sm text-foreground-600 group-hover:text-primary-600`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
              <span className="text-[10px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">{topic.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}